import "./polyfill";
import React from "react";
import ReactDOM from "react-dom";
import {Provider} from "react-redux";
import {createStore, applyMiddleware} from "redux";
import {composeWithDevTools} from "redux-devtools-extension";
import thunk from "redux-thunk";

import "./index.css";
import App from "./App";
import reducers from "./store/reducers";

let store;
if (window.location.hostname === 'localhost') {
  store = createStore(reducers, composeWithDevTools(
    applyMiddleware(thunk),
  ));
} else {
  store = createStore(reducers, applyMiddleware(thunk));
}

ReactDOM.render(
  <Provider store={store}>
    <App/>
  </Provider>,
  document.getElementById("root")
);
// disable ServiceWorker
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js